<template>
  <v-select
    v-bind="$attrs"
    :items="availableItems"
    :label="label"
    v-model="selected"
    :item-text="itemText"
    item-value="ID"
    :clearable="clearable"
    :rules="rules"
    :loading="loading"
    chips
    deletable-chips
    multiple
    dense
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
  </v-select>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
export default {
  name: 'select-multi-id-luPositions',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: 'Positions',
    },
    value: Array,
    clearable: {
      type: Boolean,
      default: false,
    },
    rules: Array,
    items: Array,
  },
  data() {
    return {
      //templateFIX: if there is more than one pick one to display
      itemText: 'Description',
    }
  },
  computed: {
    ...get('luPosition', ['luPositions', 'loading']),
    availableItems() {
      var list = []
      var fullList = []
      if (this.items) {
        fullList = this.items
        //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
        list = this.items.filter((i) => true)
      } else {
        fullList = this.luPositions.filter((i) => true)
        //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
        list = this.luPositions.filter((i) => true)
      }
      list = list.filter((i) => i.IsActive)
      // if existing record make sure the previous selection is available even if no longer active
      if (this.value > 0) {
        var selectedItem = fullList.find((i) => i.ID == this.value)
        if (!list.find((i) => i.ID == this.value) && selectedItem) {
          list.push(selectedItem)
        }
      }
      // sort by column
      list.sort((a, b) => {
        //set the property to sort on
        let textField = this.itemText
        let sort = a[textField] > b[textField] ? 1 : -1
        return sort
      })
      list.unshift({ ID: 0, Description: 'Not Evaluated', IsActive: true })
      return list
    },
    selected: {
      get() {
        if (this.value && this.value.length > 0) {
          return this.value
        } else {
          return []
        }
      },
      set(newValue) {
        this.$emit('change', newValue)
      },
    },
  },
  created() {
    if (!this.items) {
      this.loadLuPositions()
    }
  },
  methods: {
    loadLuPositions: call('luPosition/loadLuPositions'),
  },
}
</script>
<style></style>
